import type { RegisteredPanel } from '@rsos/debug-panel';
import AudioDebugPanel from './AudioDebugPanel';
import { CapabilityDebugPanel } from './CapabilityDebugPanel';
import { FlagDebugPanel } from './FlagDebugPanel';
import { InteragencyDebugPanel } from './InteragencyDebugPanel';
import { LocationDebugPanel } from './LocationDebugPanel';
import { TextTo911DebugPanel } from './TextTo911DebugPanel';

const panels: RegisteredPanel[] = [
  {
    id: 'audio-debug',
    label: 'Realtime Audio',
    component: ({ onError, onClose }) => (
      <AudioDebugPanel onError={onError} onClose={onClose} />
    ),
  },
  {
    id: 'location-debug',
    label: 'Plot Location',
    component: ({ onClose }) => <LocationDebugPanel onClose={onClose} />,
  },
  {
    id: 'tt911-debug',
    label: 'Text-to-911',
    component: ({ onClose }) => <TextTo911DebugPanel onClose={onClose} />,
  },
  {
    id: 'flag-debug',
    label: 'Feature Flags',
    component: ({ onClose }) => <FlagDebugPanel onClose={onClose} />,
  },
  {
    id: 'capability-debug',
    label: 'Capabilities',
    component: ({ onClose }) => <CapabilityDebugPanel onClose={onClose} />,
  },
  {
    id: 'interagency-debug',
    label: 'Interagency',
    component: ({ onClose }) => <InteragencyDebugPanel onClose={onClose} />,
  },
];

export default panels;
